import { render, staticRenderFns } from "./CeremonyHighlights.vue?vue&type=template&id=79d8fa1a&scoped=true"
import script from "./CeremonyHighlights.vue?vue&type=script&lang=js"
export * from "./CeremonyHighlights.vue?vue&type=script&lang=js"
import style0 from "./CeremonyHighlights.vue?vue&type=style&index=0&id=79d8fa1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d8fa1a",
  null
  
)

export default component.exports